import { instance as axios } from '../../untils/http'
import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import { errorHandler } from '../../untils/errorHandler';
import { ErrorInformation } from 'src/models/errorInformation';
import { PerformanceCurrentPlan, PerformanceAwardType , PerformanceMeasure , VestingSchedule ,
        PerformanceAwardLetter , SaveNewAward , PerformanceAwardNo , MaintainAwardDetails , UploadProfile ,
        SendAwardDetails , VestingScheduleDetail , ViewAwardList , GenerateAwardList ,
        UserDetails , PrevEmailInfo , AwardFactorDetail , SaveAwardFactor ,
        ApproveRetentionInfo , PerformanceCurrentBatchInfo , CurrentBatchDetails ,
        EnterListingDateInfo , SaveConditioArray , PerformanceCreditingProcess , SignatureDetails } from 'src/models/pspAwards';

//================|| PSP AWARD DETAILS SLICE ||=================//
type PspAwardState = {
    loading: boolean;
    error: ErrorInformation;
    performanceCurrentPlan: PerformanceCurrentPlan[];
    performanceAwardType: PerformanceAwardType[];
    performanceMeasure: PerformanceMeasure[];
    vestingSchedule: VestingSchedule[];
    performanceAwardLetter: PerformanceAwardLetter[];
    AwardLetterMessage: string;
    SaveResponse: string;
    performanceAwardNo: PerformanceAwardNo[];
    maintainAwardDetails: MaintainAwardDetails;
    uploadProfile: UploadProfile | null;
    sendAwardDetails: SendAwardDetails[];
    vestingScheduleDetail: VestingScheduleDetail[];
    viewAwardList: ViewAwardList[];
    generateAwardList: GenerateAwardList[];
    userDetails: UserDetails[];
    prevEmailInfo: PrevEmailInfo[];
    awardFactorDetail: AwardFactorDetail;
    approveRetentionInfo: ApproveRetentionInfo[];
    performanceCurrentBatchInfo: PerformanceCurrentBatchInfo;
    currentBatchDetails: CurrentBatchDetails;
    enterListingDateInfo: EnterListingDateInfo[];
    ListingPrice: number;
    performanceCreditingProcess: PerformanceCreditingProcess[];
    signatureDetails: SignatureDetails;
    ProcessAllotmentSummaryFormMessage: string;
    ProcessPaymentSummaryFormMessage: string;
    ProcessALAFormMessage: string;
    AllotmentMessage: string;
    FormCDPMessage : string;
    CDPTextMessage : string;
    ProcessSGXFormMessage : string;
    Form42Message : string;
}

type AwardInfo = {
    performanceCurrentPlan: PerformanceCurrentPlan[];
    performanceAwardType: PerformanceAwardType[];
    performanceMeasure: PerformanceMeasure[];
    vestingSchedule: VestingSchedule[];
    performanceAwardLetter: PerformanceAwardLetter[];
}

type AwardLetterParams = {
    awardNo: string,
    awardLetterID: number,
}

type uploadfile = {
    sourcePath: File,
    awardNo: string
}

const config = {
    headers: {
      "content-type": "multipart/form-data",
    },
};

type getfile = {
    csvtype: string,
    awardNo: string
}

type VestingParams = {
    awardNo: string
}

type SupervisorApprove = {
    awardNo: string,
    verifyStatus: string,
}

type userNameanduserID = {
    searchUserID: string,
    searchName: string,
}

type awardNoandemailType = {
    awardNo: string,
    emailType: number,
}

type PostAwardParams = {
    awardNo: string,
    userID: string,
    emailType: number,
    isSendManual: boolean,
    isHTMLEmail: boolean,
    subject: string,
    emailContent: string,
}

type shareTenderfile = {
    awardNo: string,
    vestingDate: string
}

type currentBranchParams = {
    creditingMode: string,
    batchNo: number,
    batchDate: string,
    marketValue: number,
    selectedAward: string,
    isLapseShare: boolean,
}

type ListingParams = {
    isCash: boolean;
}

type AssetValueParams = {
    isCash: boolean,
    batchNoList: string,
    listingDate: string,
    listingPrice: number,
}

type awardParams = {
    FromStatusID: number,
    ToStatusID: number
}

type CreditingProcessParams = {
    fromDate: string,
    endDate: string,
    isSubmitted: boolean,
}

type allotmentsummaryParams = {
    batchNo: number,
    formTypeID: string,
    sign1: number,
    sign2: number,
    page: number,
    planType: string,
    isSubmitted: boolean,
}

type processALAParams = {
    batchNo: number,
    formTypeID: string,
    alaSign1: number,
    shareCapital: number,
    issuedShares: number,
    isSubmitted: boolean,
}

type allotmentParams = {
    batchNo: number,
}

type formCDPParams = {
    batchNo: number,
    formTypeID: string,
    isSubmitted: boolean,
}

type SGXFormParams = {
    batchNo: number,
    formTypeID: string,
    sign1: number,
    isSubmitted: boolean,
}

type SubmitBatchParams = {
    batchNo: number,
    sgxSign1: number,
    allotSummarySign1: number,
    allotmentSummarySign2: number,
    paymentSummarySign1: number,
    paymentSummarySign2: number,
    ALASign1: number,
    issuedShares: number,
    paidupCapital: number,
}

type maintainAwardParams = {
    awardNo: string,
    contingentLetterID: number,
    vestingScheduleID: number,
    periodFrom: string,
    periodTo: string,
    awardDate: string,
    releaseDate: string,
    finalLetterID: number,
    vestingDate1: string,
    vestingDate2: string,
    vestingDate3: string,
    vestingDate4: string,
    vestingDate5: string,
    remarks: string,
    performanceConditionIDList: string,
    conditionArray: SaveConditioArray[],
}

const initialState: PspAwardState = {
    loading: true,
    error: null,
    performanceCurrentPlan: [],
    performanceAwardType: [],
    performanceMeasure: [],
    vestingSchedule: [],
    performanceAwardLetter: [],
    AwardLetterMessage: '',
    SaveResponse: '',
    performanceAwardNo: [],
    maintainAwardDetails: null,
    uploadProfile: null,
    sendAwardDetails: [],
    vestingScheduleDetail: [],
    viewAwardList: [],
    generateAwardList: [],
    userDetails: [],
    prevEmailInfo: [],
    awardFactorDetail: null,
    approveRetentionInfo: [],
    performanceCurrentBatchInfo: null,
    currentBatchDetails: null,
    enterListingDateInfo: [],
    ListingPrice: 0,
    performanceCreditingProcess: null,
    signatureDetails: null,
    ProcessAllotmentSummaryFormMessage: '',
    ProcessPaymentSummaryFormMessage: '',
    ProcessALAFormMessage: '',
    AllotmentMessage: '',
    FormCDPMessage: '',
    CDPTextMessage: '',
    ProcessSGXFormMessage: '',
    Form42Message: '',
};

export const getAwardDetails = createAsyncThunk<AwardInfo, {}, { rejectValue: ErrorInformation }>(
    "pspaward/getAwardDetails",
    async ({ }, { rejectWithValue }) => {
        try {
            const getPerformanceCurrentPlanResponse = await axios.get<PerformanceCurrentPlan[]>('PspMisc/performanceCurrentPlan');
            const getPerformanceAwardTypeResponse = await axios.get<PerformanceAwardType[]>('PspMisc/performanceAwardType');
            const getPerformanceMeasureResponse = await axios.get<PerformanceMeasure[]>('PspMisc/performanceMeasure');
            const vestingResponse = await axios.get<VestingSchedule[]>('/Grant/getVestingSchedule');
            const getPerformanceAwardLetter = await axios.get<PerformanceAwardLetter[]>('PspMisc/performanceAwardLetter');
            return {
                performanceCurrentPlan: getPerformanceCurrentPlanResponse.data,
                performanceAwardType: getPerformanceAwardTypeResponse.data,
                performanceMeasure: getPerformanceMeasureResponse.data,
                vestingSchedule: vestingResponse.data,
                performanceAwardLetter: getPerformanceAwardLetter.data,
            }
        } catch (error) {
            return rejectWithValue(errorHandler(error))
        }
    }
)

export const getPerformanceAwardLetterTemplate = createAsyncThunk(
    "pspaward/getPerformanceAwardLetterTemplate",
    async (awardLetterParams: AwardLetterParams, { rejectWithValue }) => {
        try {
            const getPerformanceAwardLetterTemplateResponse = await axios.get<string>(`PSP/getPerformanceAwardLetterTemplate?awardNo=${awardLetterParams.awardNo}&awardLetterID=${awardLetterParams.awardLetterID}`)
            return getPerformanceAwardLetterTemplateResponse['data']
        } catch (error) {
            return rejectWithValue(errorHandler(error))
        }
    }
)

export const setPerformanceNewAward = createAsyncThunk<number, { awardInfo: SaveNewAward }, { rejectValue: ErrorInformation }>(
    "pspaward/setPerformanceNewAward",
    async ({awardInfo}, { rejectWithValue }) => {
        try {
            const response = await axios.post('/PSP/setPerformanceNewAward', awardInfo)
            return response.data[0];
           
        } catch (error) {
            return rejectWithValue(errorHandler(error))
        }
    }
)

export const getperformanceAwardNo = createAsyncThunk<PerformanceAwardNo, {}, { rejectValue: ErrorInformation }>(
    "pspaward/getperformanceAwardNo",
    async (Params: awardParams, { rejectWithValue }) => {
        try {
            const getperformanceAwardNoResponse = await axios.get<PerformanceAwardNo>(`PspMisc/performanceAwardNo?FromStatusID=${Params.FromStatusID}&ToStatusID=${Params.ToStatusID}`)
            return getperformanceAwardNoResponse.data
        } catch (error) {
            return rejectWithValue(errorHandler(error))
        }
    }
)

export const getPerformanceAwardDetails = createAsyncThunk<MaintainAwardDetails, {}, { rejectValue: ErrorInformation }>(
    "pspaward/getPerformanceAwardDetails",
    async (awardNo: string, { rejectWithValue }) => {
        try {
            const getPerformanceAwardDetailsResponse = await axios.get<MaintainAwardDetails>(`PSP/getPerformanceAwardDetails?awardNo=${awardNo}`)
            return getPerformanceAwardDetailsResponse.data
        } catch (error) {
            return rejectWithValue(errorHandler(error))
        }
    }
)

export const setPerformanceMaintainAward = createAsyncThunk<number, { awardInfo: SaveNewAward }, { rejectValue: ErrorInformation }>(
    "pspaward/setPerformanceMaintainAward",
    async ({awardInfo}, { rejectWithValue }) => {
        try {
            const response = await axios.put('/PSP/setPerformanceMaintainAward', awardInfo)
            return response.data[0];
           
        } catch (error) {
            return rejectWithValue(errorHandler(error))
        }
    }
)

export const setPerformanceUploadAwardList = createAsyncThunk(
    "pspaward/setPerformanceUploadAwardList",
    async (uploadfile: uploadfile, { rejectWithValue }) => {
        try {
            const optionpostUploadGrant = await axios.post<UploadProfile>(`PSP/setPerformanceUploadAwardList?awardNo=${uploadfile.awardNo}`,{
                sourcePath: uploadfile.sourcePath
            }, config);
            return optionpostUploadGrant.data
        } catch (error) {
            return rejectWithValue(errorHandler(error))
        }
    }
);

export const getPerformanceUploadedAwardList = createAsyncThunk(
    "pspaward/getPerformanceUploadedAwardList",
    async (getfile: getfile, { rejectWithValue }) => {
        try {
            const getPerformanceUploadedAwardListResponse = await axios.get<string>(`PSP/getPerformanceUploadedAwardList?type=${getfile.csvtype}&awardNo=${getfile.awardNo}`)
            return getPerformanceUploadedAwardListResponse['data']
        } catch (error) {
            return rejectWithValue(errorHandler(error))
        }
    }
)

export const getPerformanceSendAwardForApproval = createAsyncThunk<SendAwardDetails, {}, { rejectValue: ErrorInformation }>(
    "pspaward/getPerformanceSendAwardForApproval",
    async ({ }, { rejectWithValue }) => {
        try {
            const getPerformanceSendAwardForApprovalResponse = await axios.get<SendAwardDetails>('PspMisc/getPerformanceSendAwardForApproval')
            return getPerformanceSendAwardForApprovalResponse.data
        } catch (error) {
            return rejectWithValue(errorHandler(error))
        }
    }
)

export const getPerformanceAwardVestingSchedule = createAsyncThunk(
    "pspaward/getPerformanceAwardVestingSchedule",
    async (vestingParams: VestingParams, { rejectWithValue }) => {
        try {
            const getVestingScheduleResponse = await axios.get<VestingScheduleDetail>(`PspMisc/getPerformanceAwardVestingSchedule?awardNo=${vestingParams.awardNo}`)
            return getVestingScheduleResponse.data
        } catch (error) {
            return rejectWithValue(errorHandler(error))
        }
    }
)

export const getPerformanceAwardList = createAsyncThunk(
    "pspaward/getPerformanceAwardList",
    async (vestingParams: VestingParams, { rejectWithValue }) => {
        try {
            const getPerformanceAwardListResponse = await axios.get<ViewAwardList>(`PspMisc/getPerformanceAwardList?awardNo=${vestingParams.awardNo}`)
            return getPerformanceAwardListResponse.data
        } catch (error) {
            return rejectWithValue(errorHandler(error))
        }
    }
)

export const setPerformanceSendAwardForApproval = createAsyncThunk(
    "pspaward/setPerformanceSendAwardForApproval",
    async (awardNo: string, { rejectWithValue }) => {
        try {
            const setPerformanceSendAwardForApprovalResponse = await axios.post<string>(`PSP/setPerformanceSendAwardForApproval?awardNo=${awardNo}`)
            return setPerformanceSendAwardForApprovalResponse.data[0];
        } catch (error) {
            return rejectWithValue(errorHandler(error))
        }
    }
)

export const getperformanceApproveAward = createAsyncThunk<SendAwardDetails, {}, { rejectValue: ErrorInformation }>(
    "pspaward/getperformanceApproveAward",
    async ({ }, { rejectWithValue }) => {
        try {
            const getperformanceApproveAwardResponse = await axios.get<SendAwardDetails>('PspMisc/getperformanceApproveAward')
            return getperformanceApproveAwardResponse.data
        } catch (error) {
            return rejectWithValue(errorHandler(error))
        }
    }
)

export const setPerformanceApproveAward = createAsyncThunk(
    "pspaward/setPerformanceApproveAward",
    async (supervisorApprove: SupervisorApprove, { rejectWithValue }) => {
        try {
            const setPerformanceApproveAwardResponse = await axios.post<string>(`PSP/setPerformanceApproveAward?awardNo=${supervisorApprove.awardNo}&verifyStatus=${supervisorApprove.verifyStatus}`)
            return setPerformanceApproveAwardResponse['data']
        } catch (error) {
            return rejectWithValue(errorHandler(error))
        }
    }
)

export const getPerformanceGenerateAwardLetter = createAsyncThunk<GenerateAwardList, {}, { rejectValue: ErrorInformation }>(
    "pspaward/getPerformanceGenerateAwardLetter",
    async ({ }, { rejectWithValue }) => {
        try {
            const getPerformanceGenerateAwardLetterResponse = await axios.get<GenerateAwardList>('PspMisc/getPerformanceGenerateAwardLetter')
            return getPerformanceGenerateAwardLetterResponse.data
        } catch (error) {
            return rejectWithValue(errorHandler(error))
        }
    }
)

export const getPerformanceLetterSearchUser = createAsyncThunk(
    "pspaward/getPerformanceLetterSearchUser",
    async (userNameanduserID: userNameanduserID, { rejectWithValue }) => {
        try {
            if(userNameanduserID.searchUserID.toString() != '' && 
            userNameanduserID.searchName.toString() != '') {
                const getPerformanceLetterSearchUserResponse = await axios.get<UserDetails[]>(`PspMisc/getPerformanceLetterSearchUser?searchUserID=${userNameanduserID.searchUserID.toString()}&searchName=${userNameanduserID.searchName.toString()}`)
                return getPerformanceLetterSearchUserResponse.data
            }
            else if(userNameanduserID.searchUserID.toString() != '') {
                const getPerformanceLetterSearchUserResponse = await axios.get<UserDetails[]>(`PspMisc/getPerformanceLetterSearchUser?searchUserID=${userNameanduserID.searchUserID.toString()}`)
                return getPerformanceLetterSearchUserResponse.data
            }
            else if(userNameanduserID.searchName.toString() != '') {
                const getPerformanceLetterSearchUserResponse = await axios.get<UserDetails[]>(`PspMisc/getPerformanceLetterSearchUser?searchName=${userNameanduserID.searchName.toString()}`)
                return getPerformanceLetterSearchUserResponse.data
            }
        } catch (error) {
            return rejectWithValue(errorHandler(error))
        }
    }
);

export const getPerformanceGenerateAwardLetterPreviewInfo = createAsyncThunk(
    "pspaward/getPerformanceGenerateAwardLetterPreviewInfo",
    async (params: awardNoandemailType, { rejectWithValue }) => {
        try {
            const PreviewInfoResponse = await axios.get<PrevEmailInfo[]>(`PSP/getPerformanceGenerateAwardLetterPreviewInfo?awardNo=${params.awardNo}&emailType=${params.emailType}`)
            return PreviewInfoResponse.data
        } catch (error) {
            return rejectWithValue(errorHandler(error))
        }
    }
);

export const setPerformanceGenerateAwardLetter = createAsyncThunk(
    "pspaward/setPerformanceGenerateAwardLetter",
    async (Params: PostAwardParams, { rejectWithValue }) => {
        try {
            console.log("Params" , Params);
            console.log(Params.userID);
            if(Params.isSendManual == true){
                const setPerformanceGenerateAwardLetterResponse = await axios.post<string>(`PSP/setPerformanceGenerateAwardLetter?awardNo=${Params.awardNo}&userID=${Params.userID}&emailType=${Params.emailType}&isSendManual=${Params.isSendManual}&isHTMLEmail=${Params.isHTMLEmail}&subject=${Params.subject}&emailContent=${Params.emailContent}`)
                return setPerformanceGenerateAwardLetterResponse.data
            }else{
                const setPerformanceGenerateAwardLetterResponse = await axios.post<string>(`PSP/setPerformanceGenerateAwardLetter?awardNo=${Params.awardNo}&emailType=${Params.emailType}&isSendManual=${Params.isSendManual}&isHTMLEmail=${Params.isHTMLEmail}&subject=${Params.subject}&emailContent=${Params.emailContent}`)
                return setPerformanceGenerateAwardLetterResponse.data
            }
        } catch (error) {
            return rejectWithValue(errorHandler(error))
        }
    }
);

// Enter Award Factor

export const getPerformanceAwardNos = createAsyncThunk<PerformanceAwardNo, {}, { rejectValue: ErrorInformation }>(
    "pspaward/getPerformanceAwardNos",
    async ({ }, { rejectWithValue }) => {
        try {
            const getPerformanceAwardNosResponse = await axios.get<PerformanceAwardNo>('PspMisc/getPerformanceAwardNos')
            return getPerformanceAwardNosResponse.data
        } catch (error) {
            return rejectWithValue(errorHandler(error))
        }
    }
)

export const getperformanceAwardLetter = createAsyncThunk<PerformanceAwardLetter, {}, { rejectValue: ErrorInformation }>(
    "pspaward/getperformanceAwardLetter",
    async ({ }, { rejectWithValue }) => {
        try {
            const performanceAwardLetterResponse = await axios.get<PerformanceAwardLetter>('PspMisc/performanceAwardLetter')
            return performanceAwardLetterResponse.data
        } catch (error) {
            return rejectWithValue(errorHandler(error))
        }
    }
)

export const getPerformanceAwardFactor = createAsyncThunk<AwardFactorDetail, {}, { rejectValue: ErrorInformation }>(
    "pspaward/getPerformanceAwardFactor",
    async (vestingParams: VestingParams, { rejectWithValue }) => {
        try {
            const getPerformanceAwardFactorResponse = await axios.get<AwardFactorDetail>(`PSP/getPerformanceAwardFactor?awardNo=${vestingParams.awardNo}`)
            return getPerformanceAwardFactorResponse['data']
            // return getPerformanceAwardFactorResponse.data[0];
        } catch (error) {
            return rejectWithValue(errorHandler(error))
        }
    }
)

export const setPerformanceUploadFinalAward = createAsyncThunk(
    "pspaward/setPerformanceUploadFinalAward",
    async (uploadfile: uploadfile, { rejectWithValue }) => {
        try {
            const optionpostUploadAward = await axios.post<UploadProfile>(`PSP/setPerformanceUploadFinalAward?awardNo=${uploadfile.awardNo}`,{
                sourceFile: uploadfile.sourcePath
            }, config);
            return optionpostUploadAward.data
        } catch (error) {
            return rejectWithValue(errorHandler(error))
        }
    }
);

export const getPerformanceUploadedFinalAward = createAsyncThunk(
    "pspaward/getPerformanceUploadedFinalAward",
    async (getfile: getfile, { rejectWithValue }) => {
        try {
            const getPerformanceUploadedFinalAwardResponse = await axios.get<string>(`PSP/getPerformanceUploadedFinalAward?type=${getfile.csvtype}&awardNo=${getfile.awardNo}`)
            return getPerformanceUploadedFinalAwardResponse['data']
        } catch (error) {
            return rejectWithValue(errorHandler(error))
        }
    }
)

export const setPerformanceAwardFactor = createAsyncThunk<number, { awardInfo: SaveAwardFactor }, { rejectValue: ErrorInformation }>(
    "pspaward/setPerformanceAwardFactor",
    async ({awardInfo}, { rejectWithValue }) => {
        try {
            const response = await axios.post('/PSP/setPerformanceAwardFactor', awardInfo)
            return response.data[0];
        } catch (error) {
            return rejectWithValue(errorHandler(error))
        }
    }
)

// Approve Retention

export const getPerformanceShareAdjustmentApproval = createAsyncThunk<ApproveRetentionInfo, {}, { rejectValue: ErrorInformation }>(
    "pspaward/getPerformanceShareAdjustmentApproval",
    async ({ }, { rejectWithValue }) => {
        try {
            const getPerformanceShareAdjustmentApprovalResponse = await axios.get<ApproveRetentionInfo>('PspMisc/getPerformanceShareAdjustmentApproval')
            return getPerformanceShareAdjustmentApprovalResponse.data
        } catch (error) {
            return rejectWithValue(errorHandler(error))
        }
    }
)

// PSP SHARE

export const getPerformanceCurrentBatchInfo = createAsyncThunk<PerformanceCurrentBatchInfo, {}, { rejectValue: ErrorInformation }>(
    "pspaward/getPerformanceCurrentBatchInfo",
    async ({ }, { rejectWithValue }) => {
        try {
            const getPerformanceCurrentBatchInfoResponse = await axios.get<PerformanceCurrentBatchInfo>('PspMisc/getPerformanceCurrentBatchInfo')
            return getPerformanceCurrentBatchInfoResponse.data
        } catch (error) {
            return rejectWithValue(errorHandler(error))
        }
    }
)

export const getPerformanceSignature = createAsyncThunk<SignatureDetails, {}, { rejectValue: ErrorInformation }>(
    "pspaward/getPerformanceSignature",
    async ({ }, { rejectWithValue }) => {
        try {
            const getPerformanceCurrentBatchInfoResponse = await axios.get<SignatureDetails>('PspMisc/getPerformanceSignature')
            return getPerformanceCurrentBatchInfoResponse.data
        } catch (error) {
            return rejectWithValue(errorHandler(error))
        }
    }
)

export const getPerformanceCreditingProcessByDate = createAsyncThunk(
    "pspaward/getPerformanceCreditingProcessByDate",
    async (params: CreditingProcessParams, { rejectWithValue }) => {
        try {
            const getPerformanceCreditingProcessByDateResponse = await axios.get<PerformanceCreditingProcess[]>(`PSP/getPerformanceCreditingProcessByDate?fromDate=${params.fromDate}&endDate=${params.endDate}&isSubmitted=${params.isSubmitted}`)
            return getPerformanceCreditingProcessByDateResponse.data
        } catch (error) {
            return rejectWithValue(errorHandler(error))
        }
    }
);

export const processAllotmentSummaryForm = createAsyncThunk(
    "pspaward/processAllotmentSummaryForm",
    async (Params: allotmentsummaryParams, { rejectWithValue }) => {
        try {
            const processAllotmentSummaryFormResponse = await axios.get<string>(`PSP/processAllotmentSummaryForm?batchNo=${Params.batchNo}&formTypeID=${Params.formTypeID}
                &sign1=${Params.sign1}&sign2=${Params.sign2}&page=${Params.page}&planType=${Params.planType}&isSubmitted=${Params.isSubmitted}`)
            return processAllotmentSummaryFormResponse['data']
        } catch (error) {
            return rejectWithValue(errorHandler(error))
        }
    }
)

export const ProcessPaymentSummaryForm = createAsyncThunk(
    "pspaward/ProcessPaymentSummaryForm",
    async (Params: allotmentsummaryParams, { rejectWithValue }) => {
        try {
            const ProcessPaymentSummaryFormResponse = await axios.get<string>(`PSP/ProcessPaymentSummaryForm?batchNo=${Params.batchNo}&formTypeID=${Params.formTypeID}
                &sign1=${Params.sign1}&sign2=${Params.sign2}&page=${Params.page}&planType=${Params.planType}&isSubmitted=${Params.isSubmitted}`)
            return ProcessPaymentSummaryFormResponse['data']
        } catch (error) {
            return rejectWithValue(errorHandler(error))
        }
    }
)

export const processSGXForm = createAsyncThunk(
    "pspaward/processSGXForm",
    async (Params: SGXFormParams, { rejectWithValue }) => {
        try {
            const processSGXFormResponse = await axios.get<string>(`PSP/processSGXForm?batchNo=${Params.batchNo}&formTypeID=${Params.formTypeID}
                &sign1${Params.sign1}&isSubmitted=${Params.isSubmitted}`)
            return processSGXFormResponse['data']
        } catch (error) {
            return rejectWithValue(errorHandler(error))
        }
    }
)

export const ProcessALAForm = createAsyncThunk(
    "pspaward/ProcessALAForm",
    async (Params: processALAParams, { rejectWithValue }) => {
        try {
            const ProcessALAFormResponse = await axios.get<string>(`PSP/ProcessALAForm?batchNo=${Params.batchNo}&formTypeID=${Params.formTypeID}
                &alaSign1=${Params.alaSign1}&shareCapital=${Params.shareCapital}&issuedShares=${Params.issuedShares}&isSubmitted=${Params.isSubmitted}`)
            return ProcessALAFormResponse['data']
        } catch (error) {
            return rejectWithValue(errorHandler(error))
        }
    }
)

export const GenerateReport = createAsyncThunk(
    "pspaward/GenerateReport",
    async (Params: allotmentParams, { rejectWithValue }) => {
        try {
            const GenerateReportResponse = await axios.get<string>(`PSP/GenerateReport?batchNo=${Params.batchNo}`)
            return GenerateReportResponse['data']
        } catch (error) {
            return rejectWithValue(errorHandler(error))
        }
    }
)

export const ProcessCDPForm = createAsyncThunk(
    "pspaward/ProcessCDPForm",
    async (Params: formCDPParams, { rejectWithValue }) => {
        try {
            const ProcessCDPFormResponse = await axios.get<string>(`PSP/ProcessCDPForm?batchNo=${Params.batchNo}&formTypeID=${Params.formTypeID}&isSubmitted=${Params.isSubmitted}`)
            return ProcessCDPFormResponse['data']
        } catch (error) {
            return rejectWithValue(errorHandler(error))
        }
    }
)

export const ProcessCDPTextFile = createAsyncThunk(
    "pspaward/ProcessCDPTextFile",
    async (Params: formCDPParams, { rejectWithValue }) => {
        try {
            const ProcessCDPTextFileResponse = await axios.get<string>(`PSP/ProcessCDPTextFile?batchNo=${Params.batchNo}&formTypeID=${Params.formTypeID}&isSubmitted=${Params.isSubmitted}`)
            return ProcessCDPTextFileResponse['data']
        } catch (error) {
            return rejectWithValue(errorHandler(error))
        }
    }
)

export const ProcessForm42 = createAsyncThunk(
    "pspaward/ProcessForm42",
    async (Params: formCDPParams, { rejectWithValue }) => {
        try {
            const ProcessForm42Response = await axios.get<string>(`PSP/ProcessForm42?batchNo=${Params.batchNo}&formTypeID=${Params.formTypeID}&isSubmitted=${Params.isSubmitted}`)
            return ProcessForm42Response['data']
        } catch (error) {
            return rejectWithValue(errorHandler(error))
        }
    }
)

export const setPerformanceCreditingProcessSubmit = createAsyncThunk(
    "pspaward/setPerformanceCreditingProcessSubmit",
    async (Params: SubmitBatchParams, { rejectWithValue }) => {
        try {
            const setPerformanceCreditingProcessSubmitResponse = await axios.post<string>(`PSP/setPerformanceCreditingProcessSubmit?batchNo=${Params.batchNo}
                &sgxSign1=${Params.sgxSign1}&allotSummarySign1=${Params.allotSummarySign1}&allotmentSummarySign2=${Params.allotmentSummarySign2}
                &paymentSummarySign1=${Params.paymentSummarySign1}&paymentSummarySign2=${Params.paymentSummarySign2}&ALASign1=${Params.ALASign1}
                &issuedShares=${Params.issuedShares}&paidupCapital=${Params.paidupCapital}`)
            return setPerformanceCreditingProcessSubmitResponse.data[0];
        } catch (error) {
            return rejectWithValue(errorHandler(error))
        }
    }
)

export const setPerformanceCreditingProcessResubmit = createAsyncThunk(
    "pspaward/setPerformanceCreditingProcessResubmit",
    async (batchNo: string, { rejectWithValue }) => {
        try {
            const setPerformanceCreditingProcessResubmitResponse = await axios.post<string>(`PSP/setPerformanceCreditingProcessResubmit?batchNo=${batchNo}`)
            return setPerformanceCreditingProcessResubmitResponse.data[0];
        } catch (error) {
            return rejectWithValue(errorHandler(error))
        }
    }
)

export const deletePerformanceBatch = createAsyncThunk(
    "pspaward/deletePerformanceBatch",
    async (batchNo: string, { rejectWithValue }) => {
        try {
            const deletePerformanceBatchResponse = await axios.delete<string>(`PSP/deletePerformanceBatch?batchNo=${batchNo}`)
            return deletePerformanceBatchResponse.data[0];
        } catch (error) {
            return rejectWithValue(errorHandler(error))
        }
    }
)

export const getPerformanceParticipantTenderedResignation = createAsyncThunk(
    "pspaward/getPerformanceParticipantTenderedResignation",
    async (params: shareTenderfile, { rejectWithValue }) => {
        try {
            const getPerformanceParticipantTenderedResignationResponse = await axios.get<string>(`PspMisc/getPerformanceParticipantTenderedResignation?awardNo=${params.awardNo}&vestingDate=${params.vestingDate}`)
            return getPerformanceParticipantTenderedResignationResponse['data']
        } catch (error) {
            return rejectWithValue(errorHandler(error))
        }
    }
)

export const getPerformanceParticipantAll = createAsyncThunk(
    "pspaward/getPerformanceParticipantAll",
    async (params: shareTenderfile, { rejectWithValue }) => {
        try {
            const getPerformanceParticipantAllResponse = await axios.get<string>(`PspMisc/getPerformanceParticipantAll?awardNo=${params.awardNo}&vestingDate=${params.vestingDate}`)
            return getPerformanceParticipantAllResponse['data']
        } catch (error) {
            return rejectWithValue(errorHandler(error))
        }
    }
)

export const setPerformanceCreditingProcessDraft = createAsyncThunk(
    "pspaward/setPerformanceCreditingProcessDraft",
    async (Params: currentBranchParams, { rejectWithValue }) => {
        try {
            const setPerformanceCreditingProcessDraftResponse = await axios.post<string>(`PSP/setPerformanceCreditingProcessDraft?creditingMode=${Params.creditingMode}&batchNo=${Params.batchNo}&batchDate=${Params.batchDate}&marketValue=${Params.marketValue}&selectedAward=${Params.selectedAward}&isLapseShare=${Params.isLapseShare}`)
            return setPerformanceCreditingProcessDraftResponse.data
        } catch (error) {
            return rejectWithValue(errorHandler(error))
        }
    }
);

export const setPerformanceCreditingTotalShareUpdate = createAsyncThunk(
    "pspaward/setPerformanceCreditingTotalShareUpdate",
    async (Params: VestingParams, { rejectWithValue }) => {
        try {
            const setPerformanceCreditingTotalShareUpdateResponse = await axios.post<string>(`PSP/setPerformanceCreditingTotalShareUpdate?batchNo=${Params.awardNo}`)
            return setPerformanceCreditingTotalShareUpdateResponse.data
        } catch (error) {
            return rejectWithValue(errorHandler(error))
        }
    }
);

export const getPerformanceCreditingBatchInfo = createAsyncThunk(
    "pspaward/getPerformanceCreditingBatchInfo",
    async (vestingParams: VestingParams, { rejectWithValue }) => {
        try {
            const getPerformanceCreditingBatchInfoResponse = await axios.get<CurrentBatchDetails>(`PspMisc/getPerformanceCreditingBatchInfo?batchNo=${vestingParams.awardNo}`)
            return getPerformanceCreditingBatchInfoResponse.data
        } catch (error) {
            return rejectWithValue(errorHandler(error))
        }
    }
)

export const getPerformanceListingDateBatchNo = createAsyncThunk(
    "pspaward/getPerformanceListingDateBatchNo",
    async (Params: ListingParams, { rejectWithValue }) => {
        try {
            const getPerformanceListingDateBatchNoResponse = await axios.get<EnterListingDateInfo>(`PspMisc/getPerformanceListingDateBatchNo?isCash=${Params.isCash}`)
            return getPerformanceListingDateBatchNoResponse.data
        } catch (error) {
            return rejectWithValue(errorHandler(error))
        }
    }
)

export const getStockPrice = createAsyncThunk(
    "pspaward/getStockPrice",
    async (Params: VestingParams, { rejectWithValue }) => {
        try {
            const getStockPriceResponse = await axios.get<number>(`PspMisc/getStockPrice?vestingDate=${Params.awardNo}`)
            return getStockPriceResponse.data
        } catch (error) {
            return rejectWithValue(errorHandler(error))
        }
    }
)

export const setPerformanceListingDate = createAsyncThunk(
    "pspaward/setPerformanceListingDate",
    async (assetValueParams: AssetValueParams, { rejectWithValue }) => {
        try {
            const setListingDateResponse = await axios.post<string>(`PSP/setPerformanceListingDate?isCash=${assetValueParams.isCash}
                &batchNoList=${assetValueParams.batchNoList}
                &listingDate=${assetValueParams.listingDate}&listingPrice=${assetValueParams.listingPrice}`)
            return setListingDateResponse.data[0];
        } catch (error) {
            return rejectWithValue(errorHandler(error))
        }
    }
)

const pspAwardSlice = createSlice({
    name: 'pspaward',
    initialState,
    reducers: {},
    extraReducers: {
        //get Performance Current , Award Type , Measure deatils
        [getAwardDetails.pending.type]: (state) => {
            state.loading = true;
        },
        [getAwardDetails.fulfilled.type]: (state, action) => {
            const { performanceCurrentPlan , performanceAwardType , performanceMeasure , 
                    vestingSchedule , performanceAwardLetter } = action.payload
            state.performanceCurrentPlan = performanceCurrentPlan;
            state.performanceAwardType = performanceAwardType;
            state.performanceMeasure = performanceMeasure;
            state.vestingSchedule = vestingSchedule;
            state.performanceAwardLetter = performanceAwardLetter;
            state.loading = false;
        },
        [getAwardDetails.rejected.type]: (state, action: PayloadAction<any | null>) => {
            state.loading = false;
            state.error = action.payload;
        },

        //get Letter To CDP detail
        [getPerformanceAwardLetterTemplate.pending.type]: (state) => {
            state.loading = true;
        },
        [getPerformanceAwardLetterTemplate.fulfilled.type]: (state, action) => {
            state.AwardLetterMessage = action.payload;
            state.loading = false;
        },
        [getPerformanceAwardLetterTemplate.rejected.type]: (state, action: PayloadAction<ErrorInformation | null>) => {
            state.loading = false;
            state.error = action.payload
        },

        // Save Create Award
        [setPerformanceNewAward.pending.type]: (state) => {
            state.loading = true;
        },
        [setPerformanceNewAward.fulfilled.type]: (state, action: PayloadAction<string | ''>) => {
            state.SaveResponse = action.payload
            state.loading = false;
            state.error = null;
        },
        [setPerformanceNewAward.rejected.type]: (state, action: PayloadAction<ErrorInformation | null>) => {
            state.loading = false;
            state.error = action.payload;
        },
        
        // Maintain Award
        //get Award No 
        [getperformanceAwardNo.pending.type]: (state) => {
            state.loading = true;
        },
        [getperformanceAwardNo.fulfilled.type]: (state, action) => {
            state.performanceAwardNo = action.payload;
            state.loading = false;
        },
        [getperformanceAwardNo.rejected.type]: (state, action: PayloadAction<any | null>) => {
            state.loading = false;
            state.error = action.payload;
        },

        // Save Maintain Award
        [setPerformanceMaintainAward.pending.type]: (state) => {
            state.loading = true;
        },
        [setPerformanceMaintainAward.fulfilled.type]: (state, action: PayloadAction<string | ''>) => {
            state.SaveResponse = action.payload
            state.loading = false;
            state.error = null;
        },
        [setPerformanceMaintainAward.rejected.type]: (state, action: PayloadAction<ErrorInformation | null>) => {
            state.loading = false;
            state.error = action.payload;
        },

        //get Award List
        [getPerformanceAwardDetails.pending.type]: (state) => {
            state.loading = true;
        },
        [getPerformanceAwardDetails.fulfilled.type]: (state, action) => {
            state.maintainAwardDetails = action.payload;
            state.loading = false;
        },
        [getPerformanceAwardDetails.rejected.type]: (state, action: PayloadAction<any | null>) => {
            state.loading = false;
            state.error = action.payload;
        },
        
        // Upload Award
        [setPerformanceUploadAwardList.pending.type]: (state) => {
            state.loading = true;
        },
        [setPerformanceUploadAwardList.fulfilled.type]: (state, action) => {
            state.uploadProfile = action.payload;
            state.loading = false;
            state.error = null;
        },
        [setPerformanceUploadAwardList.rejected.type]: (state, action: PayloadAction<ErrorInformation | null>) => {
            state.loading = false;
            state.error = action.payload;
        },
        
        //get Upload Award List Success & Exception
        [getPerformanceUploadedAwardList.pending.type]: (state) => {
            state.loading = true;
        },
        [getPerformanceUploadedAwardList.fulfilled.type]: (state, action) => {
            state.loading = false;
            state.error = null;
        },
        [getPerformanceUploadedAwardList.rejected.type]: (state, action: PayloadAction<ErrorInformation | null>) => {
            state.loading = false;
            state.error = action.payload
        },
        
        //get Send Award For Approval
        [getPerformanceSendAwardForApproval.pending.type]: (state) => {
            state.loading = true;
        },
        [getPerformanceSendAwardForApproval.fulfilled.type]: (state, action) => {
            state.sendAwardDetails = action.payload;
            state.loading = false;
        },
        [getPerformanceSendAwardForApproval.rejected.type]: (state, action: PayloadAction<any | null>) => {
            state.loading = false;
            state.error = action.payload;
        },

        //get Vesting Schedule
        [getPerformanceAwardVestingSchedule.pending.type]: (state) => {
            state.loading = true;
        },
        [getPerformanceAwardVestingSchedule.fulfilled.type]: (state, action) => {
            state.vestingScheduleDetail = action.payload;
            state.loading = false;
        },
        [getPerformanceAwardVestingSchedule.rejected.type]: (state, action: PayloadAction<ErrorInformation | null>) => {
            state.loading = false;
            state.error = action.payload
        },
        
        //get View Award List
        [getPerformanceAwardList.pending.type]: (state) => {
            state.loading = true;
        },
        [getPerformanceAwardList.fulfilled.type]: (state, action) => {
            state.viewAwardList = action.payload;
            state.loading = false;
        },
        [getPerformanceAwardList.rejected.type]: (state, action: PayloadAction<any | null>) => {
            state.loading = false;
            state.error = action.payload;
        },
        
        // Send Grant For Approval
        [setPerformanceSendAwardForApproval.pending.type]: (state) => {
            state.loading = true;
        },
        [setPerformanceSendAwardForApproval.fulfilled.type]: (state, action: PayloadAction<string | ''>) => {
            state.SaveResponse = action.payload
            state.loading = false;
            state.error = null;
        },
        [setPerformanceSendAwardForApproval.rejected.type]: (state, action: PayloadAction<ErrorInformation | null>) => {
            state.loading = false;
            state.error = action.payload;
        },
        
        // Post Supervisor Award For Approval
        [setPerformanceApproveAward.pending.type]: (state) => {
            state.loading = true;
        },
        [setPerformanceApproveAward.fulfilled.type]: (state, action: PayloadAction<string | ''>) => {
            state.SaveResponse = action.payload
            state.loading = false;
            state.error = null;
        },
        [setPerformanceApproveAward.rejected.type]: (state, action: PayloadAction<ErrorInformation | null>) => {
            state.loading = false;
            state.error = action.payload;
        },

        //get Award For Approval
        [getperformanceApproveAward.pending.type]: (state) => {
            state.loading = true;
        },
        [getperformanceApproveAward.fulfilled.type]: (state, action) => {
            state.sendAwardDetails = action.payload;
            state.loading = false;
        },
        [getperformanceApproveAward.rejected.type]: (state, action: PayloadAction<any | null>) => {
            state.loading = false;
            state.error = action.payload;
        },

        //get Generate Award Letter Info
        [getPerformanceGenerateAwardLetter.pending.type]: (state) => {
            state.loading = true;
        },
        [getPerformanceGenerateAwardLetter.fulfilled.type]: (state, action) => {
            state.generateAwardList = action.payload;
            state.loading = false;
        },
        [getPerformanceGenerateAwardLetter.rejected.type]: (state, action: PayloadAction<any | null>) => {
            state.loading = false;
            state.error = action.payload;
        },
        
        //Generate Offer get User List View
        [getPerformanceLetterSearchUser.pending.type]: (state) => {
            state.loading = true;
        },
        [getPerformanceLetterSearchUser.fulfilled.type]: (state, action) => {
            state.userDetails = action.payload;
            state.loading = false;
            state.error = null;
        },
        [getPerformanceLetterSearchUser.rejected.type]: (state, action: PayloadAction<ErrorInformation | null>) => {
            state.loading = false;
            state.error = action.payload
        },
        
        // Generate Award Leter Preview Email
        [getPerformanceGenerateAwardLetterPreviewInfo.pending.type]: (state) => {
            state.loading = true;
        },
        [getPerformanceGenerateAwardLetterPreviewInfo.fulfilled.type]: (state, action) => {
            state.prevEmailInfo = action.payload;
            state.loading = false;
            state.error = null;
        },
        [getPerformanceGenerateAwardLetterPreviewInfo.rejected.type]: (state, action: PayloadAction<ErrorInformation | null>) => {
            state.loading = false;
            state.error = action.payload
        },

        // Send Mail for Generate Award Letter
        [setPerformanceGenerateAwardLetter.pending.type]: (state) => {
            state.loading = true;
        },
        [setPerformanceGenerateAwardLetter.fulfilled.type]: (state, action: PayloadAction<string | ''>) => {
            state.SaveResponse = action.payload
            state.loading = false;
            state.error = null;
        },
        [setPerformanceGenerateAwardLetter.rejected.type]: (state, action: PayloadAction<ErrorInformation | null>) => {
            state.loading = false;
            state.error = action.payload;
        },

        // Enter Award List
        //get Award No For Award List
        [getPerformanceAwardNos.pending.type]: (state) => {
            state.loading = true;
        },
        [getPerformanceAwardNos.fulfilled.type]: (state, action) => {
            state.performanceAwardNo = action.payload;
            state.loading = false;
        },
        [getPerformanceAwardNos.rejected.type]: (state, action: PayloadAction<any | null>) => {
            state.loading = false;
            state.error = action.payload;
        },

        //get Performance Award Letter For Award List
        [getperformanceAwardLetter.pending.type]: (state) => {
            state.loading = true;
        },
        [getperformanceAwardLetter.fulfilled.type]: (state, action) => {
            state.performanceAwardLetter = action.payload;
            state.loading = false;
        },
        [getperformanceAwardLetter.rejected.type]: (state, action: PayloadAction<any | null>) => {
            state.loading = false;
            state.error = action.payload;
        },
        
        //get Performance Award Factor List
        [getPerformanceAwardFactor.pending.type]: (state) => {
            state.loading = true;
        },
        [getPerformanceAwardFactor.fulfilled.type]: (state, action) => {
            state.awardFactorDetail = action.payload;
            state.loading = false;
        },
        [getPerformanceAwardFactor.rejected.type]: (state, action: PayloadAction<any | null>) => {
            state.loading = false;
            state.error = action.payload;
        },

         // Upload Final Award
        [setPerformanceUploadFinalAward.pending.type]: (state) => {
            state.loading = true;
        },
        [setPerformanceUploadFinalAward.fulfilled.type]: (state, action) => {
            state.uploadProfile = action.payload;
            state.loading = false;
            state.error = null;
        },
        [setPerformanceUploadFinalAward.rejected.type]: (state, action: PayloadAction<ErrorInformation | null>) => {
            state.loading = false;
            state.error = action.payload;
        },

        //get Upload Final Award List Success & Exception
        [getPerformanceUploadedFinalAward.pending.type]: (state) => {
            state.loading = true;
        },
        [getPerformanceUploadedFinalAward.fulfilled.type]: (state, action) => {
            state.loading = false;
            state.error = null;
        },
        [getPerformanceUploadedFinalAward.rejected.type]: (state, action: PayloadAction<ErrorInformation | null>) => {
            state.loading = false;
            state.error = action.payload
        },

        // Save Final Award Factor
        [setPerformanceAwardFactor.pending.type]: (state) => {
            state.loading = true;
        },
        [setPerformanceAwardFactor.fulfilled.type]: (state, action: PayloadAction<string | ''>) => {
            state.SaveResponse = action.payload
            state.loading = false;
            state.error = null;
        },
        [setPerformanceAwardFactor.rejected.type]: (state, action: PayloadAction<ErrorInformation | null>) => {
            state.loading = false;
            state.error = action.payload;
        },

        //get Approval Retention
        [getPerformanceShareAdjustmentApproval.pending.type]: (state) => {
            state.loading = true;
        },
        [getPerformanceShareAdjustmentApproval.fulfilled.type]: (state, action) => {
            state.approveRetentionInfo = action.payload;
            state.loading = false;
        },
        [getPerformanceShareAdjustmentApproval.rejected.type]: (state, action: PayloadAction<any | null>) => {
            state.loading = false;
            state.error = action.payload;
        },

        // PSP SHARE
        // get Performance Current Batch
        [getPerformanceCurrentBatchInfo.pending.type]: (state) => {
            state.loading = true;
        },
        [getPerformanceCurrentBatchInfo.fulfilled.type]: (state, action) => {
            state.performanceCurrentBatchInfo = action.payload;
            state.loading = false;
        },
        [getPerformanceCurrentBatchInfo.rejected.type]: (state, action: PayloadAction<any | null>) => {
            state.loading = false;
            state.error = action.payload;
        },

        // get Performance Signature
        [getPerformanceSignature.pending.type]: (state) => {
            state.loading = true;
        },
        [getPerformanceSignature.fulfilled.type]: (state, action) => {
            state.signatureDetails = action.payload;
            state.loading = false;
        },
        [getPerformanceSignature.rejected.type]: (state, action: PayloadAction<any | null>) => {
            state.loading = false;
            state.error = action.payload;
        },

        //get Performance Crediting Process By Date
        [getPerformanceCreditingProcessByDate.pending.type]: (state) => {
            state.loading = true;
        },
        [getPerformanceCreditingProcessByDate.fulfilled.type]: (state, action) => {
            state.performanceCreditingProcess = action.payload;
            state.loading = false;
        },
        [getPerformanceCreditingProcessByDate.rejected.type]: (state, action: PayloadAction<any | null>) => {
            state.loading = false;
            state.error = action.payload;
        },

        //get Process Allotment Summary Form
        [processAllotmentSummaryForm.pending.type]: (state) => {
            state.loading = true;
        },
        [processAllotmentSummaryForm.fulfilled.type]: (state, action) => {
            state.ProcessAllotmentSummaryFormMessage = action.payload;
            state.loading = false;
        },
        [processAllotmentSummaryForm.rejected.type]: (state, action: PayloadAction<ErrorInformation | null>) => {
            state.loading = false;
            state.error = action.payload
        },

        //get Process Payment Summary Form
        [ProcessPaymentSummaryForm.pending.type]: (state) => {
            state.loading = true;
        },
        [ProcessPaymentSummaryForm.fulfilled.type]: (state, action) => {
            state.ProcessPaymentSummaryFormMessage = action.payload;
            state.loading = false;
        },
        [ProcessPaymentSummaryForm.rejected.type]: (state, action: PayloadAction<ErrorInformation | null>) => {
            state.loading = false;
            state.error = action.payload
        },

        //get Process SGX Form
        [processSGXForm.pending.type]: (state) => {
            state.loading = true;
        },
        [processSGXForm.fulfilled.type]: (state, action) => {
            state.ProcessSGXFormMessage = action.payload;
            state.loading = false;
        },
        [processSGXForm.rejected.type]: (state, action: PayloadAction<ErrorInformation | null>) => {
            state.loading = false;
            state.error = action.payload
        },

        //get Process ALA Form
        [ProcessALAForm.pending.type]: (state) => {
            state.loading = true;
        },
        [ProcessALAForm.fulfilled.type]: (state, action) => {
            state.ProcessALAFormMessage = action.payload;
            state.loading = false;
        },
        [ProcessALAForm.rejected.type]: (state, action: PayloadAction<ErrorInformation | null>) => {
            state.loading = false;
            state.error = action.payload
        },

        //get Allotment Report
        [GenerateReport.pending.type]: (state) => {
            state.loading = true;
        },
        [GenerateReport.fulfilled.type]: (state, action) => {
            state.AllotmentMessage = action.payload;
            state.loading = false;
        },
        [GenerateReport.rejected.type]: (state, action: PayloadAction<ErrorInformation | null>) => {
            state.loading = false;
            state.error = action.payload
        },

        //get Form CDP
        [ProcessCDPForm.pending.type]: (state) => {
            state.loading = true;
        },
        [ProcessCDPForm.fulfilled.type]: (state, action) => {
            state.FormCDPMessage = action.payload;
            state.loading = false;
        },
        [ProcessCDPForm.rejected.type]: (state, action: PayloadAction<ErrorInformation | null>) => {
            state.loading = false;
            state.error = action.payload
        },

        //get CDP Text File
        [ProcessCDPTextFile.pending.type]: (state) => {
            state.loading = true;
        },
        [ProcessCDPTextFile.fulfilled.type]: (state, action) => {
            state.CDPTextMessage = action.payload;
            state.loading = false;
        },
        [ProcessCDPTextFile.rejected.type]: (state, action: PayloadAction<ErrorInformation | null>) => {
            state.loading = false;
            state.error = action.payload
        },

        //get Form 42
        [ProcessForm42.pending.type]: (state) => {
            state.loading = true;
        },
        [ProcessForm42.fulfilled.type]: (state, action) => {
            state.Form42Message = action.payload;
            state.loading = false;
        },
        [ProcessForm42.rejected.type]: (state, action: PayloadAction<ErrorInformation | null>) => {
            state.loading = false;
            state.error = action.payload
        },

        // Submit Batch
        [setPerformanceCreditingProcessSubmit.pending.type]: (state) => {
            state.loading = true;
        },
        [setPerformanceCreditingProcessSubmit.fulfilled.type]: (state, action: PayloadAction<string | ''>) => {
            state.SaveResponse = action.payload
            state.loading = false;
            state.error = null;
        },
        [setPerformanceCreditingProcessSubmit.rejected.type]: (state, action: PayloadAction<ErrorInformation | null>) => {
            state.loading = false;
            state.error = action.payload;
        },

        // ReSubmit Batch
        [setPerformanceCreditingProcessResubmit.pending.type]: (state) => {
            state.loading = true;
        },
        [setPerformanceCreditingProcessResubmit.fulfilled.type]: (state, action: PayloadAction<string | ''>) => {
            state.SaveResponse = action.payload
            state.loading = false;
            state.error = null;
        },
        [setPerformanceCreditingProcessResubmit.rejected.type]: (state, action: PayloadAction<ErrorInformation | null>) => {
            state.loading = false;
            state.error = action.payload;
        },

        // Delete Batch
        [deletePerformanceBatch.pending.type]: (state) => {
            state.loading = true;
        },
        [deletePerformanceBatch.fulfilled.type]: (state, action: PayloadAction<string | ''>) => {
            state.SaveResponse = action.payload
            state.loading = false;
            state.error = null;
        },
        [deletePerformanceBatch.rejected.type]: (state, action: PayloadAction<ErrorInformation | null>) => {
            state.loading = false;
            state.error = action.payload;
        },

        //get Performance Participant Tendered Resignation
        [getPerformanceParticipantTenderedResignation.pending.type]: (state) => {
            state.loading = true;
        },
        [getPerformanceParticipantTenderedResignation.fulfilled.type]: (state, action) => {
            state.loading = false;
            state.error = null;
        },
        [getPerformanceParticipantTenderedResignation.rejected.type]: (state, action: PayloadAction<ErrorInformation | null>) => {
            state.loading = false;
            state.error = action.payload
        },
        
        //get Performance Participant Tendered Resignation
        [getPerformanceParticipantAll.pending.type]: (state) => {
            state.loading = true;
        },
        [getPerformanceParticipantAll.fulfilled.type]: (state, action) => {
            state.loading = false;
            state.error = null;
        },
        [getPerformanceParticipantAll.rejected.type]: (state, action: PayloadAction<ErrorInformation | null>) => {
            state.loading = false;
            state.error = action.payload
        },

        // Generate Current Batch
        [setPerformanceCreditingProcessDraft.pending.type]: (state) => {
            state.loading = true;
        },
        [setPerformanceCreditingProcessDraft.fulfilled.type]: (state, action: PayloadAction<string | ''>) => {
            state.SaveResponse = action.payload
            state.loading = false;
            state.error = null;
        },
        [setPerformanceCreditingProcessDraft.rejected.type]: (state, action: PayloadAction<ErrorInformation | null>) => {
            state.loading = false;
            state.error = action.payload;
        },

        [setPerformanceCreditingTotalShareUpdate.pending.type]: (state) => {
            state.loading = true;
        },
        [setPerformanceCreditingTotalShareUpdate.fulfilled.type]: (state, action: PayloadAction<string | ''>) => {
            state.SaveResponse = action.payload
            state.loading = false;
            state.error = null;
        },
        [setPerformanceCreditingTotalShareUpdate.rejected.type]: (state, action: PayloadAction<ErrorInformation | null>) => {
            state.loading = false;
            state.error = action.payload;
        },

        [getPerformanceCreditingBatchInfo.pending.type]: (state) => {
            state.loading = true;
        },
        [getPerformanceCreditingBatchInfo.fulfilled.type]: (state, action) => {
            state.currentBatchDetails = action.payload;
            state.loading = false;
        },
        [getPerformanceCreditingBatchInfo.rejected.type]: (state, action: PayloadAction<any | null>) => {
            state.loading = false;
            state.error = action.payload;
        },

        // PSP - Share Listing / Creating Date Batch Info
        [getPerformanceListingDateBatchNo.pending.type]: (state) => {
            state.loading = true;
        },
        [getPerformanceListingDateBatchNo.fulfilled.type]: (state, action) => {
            state.enterListingDateInfo = action.payload;
            state.loading = false;
        },
        [getPerformanceListingDateBatchNo.rejected.type]: (state, action: PayloadAction<any | null>) => {
            state.loading = false;
            state.error = action.payload;
        },

        // PSP - Share Get Price
        [getStockPrice.pending.type]: (state) => {
            state.loading = true;
        },
        [getStockPrice.fulfilled.type]: (state, action) => {
            state.ListingPrice = action.payload;
            state.loading = false;
        },
        [getStockPrice.rejected.type]: (state, action: PayloadAction<any | null>) => {
            state.loading = false;
            state.error = action.payload;
        },
        
        // Enter Listing Save
        [setPerformanceListingDate.pending.type]: (state) => {
            state.loading = true;
        },
        [setPerformanceListingDate.fulfilled.type]: (state, action: PayloadAction<string | ''>) => {
            state.SaveResponse = action.payload
            state.loading = false;
            state.error = null;
        },
        [setPerformanceListingDate.rejected.type]: (state, action: PayloadAction<ErrorInformation | null>) => {
            state.loading = false;
            state.error = action.payload;
        },
    }
})
export default pspAwardSlice